import { memo } from 'react';
import Typography from '../Typography';

export enum SnackbarSeverityEnum {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export interface SnackbarProps {
  title: string | null,
  text: string | null;
  severity: SnackbarSeverityEnum;
}

interface ISnackbarMessageProps {
  title: string | null;
  body: string | null;
}

const SnackbarMessage = (props: ISnackbarMessageProps) => {
  const { title, body } = props;
  return (
    <>
      {title && (<Typography variant="caption" sx={{ fontWeight: 600 }}>{title}</Typography>)}
      {body && (<Typography variant="body2">{body}</Typography>)}
    </>
  );
};

export default memo(SnackbarMessage);
